import { Columns } from '@/components/Columns';
import { LabradorComponent } from '@/types/component';

import { withGridSystem } from '@/utils/withGridSystem';
import { renderContentComponent } from 'modules/dynamic/components';
import { Fragment } from 'react';

export const LabradorColumns: LabradorComponent = ({ type, meta, data, descendants, ...props }) => {
  const contentIndex = meta.contentIndex;

  if (!descendants?.length) {
    return null;
  }

  const content = descendants.map((child, index) => {
    return <Fragment key={index}>{renderContentComponent(child)}</Fragment>;
  });

  return (
    <Columns
      options={{ className: withGridSystem(meta.width) }}
      data-content-index={contentIndex}
      {...{ content }}
      {...props}
    />
  );
};
